import { sva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const avatarRecipe = sva({
    slots: ['root', 'image'],
    base: {
        root: {
            cursor: 'pointer',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            backgroundColor: 'colorPalette.fill',
            color: 'colorPalette.contrast',
            // this forces the SVG to this height
            // it is not very customizable
            // may want to re-think this
            _icon: {
                width: '[100%]',
            },
        },
        image: {
            width: '[100%]',
            height: '[100%]',
            objectFit: 'cover',
        },
    },
    variants: {
        size: {
            small: {
                root: {
                    fontSize: '[0.75rem]',
                    width: '[1.5rem]',
                    height: '[1.5rem]',
                },
            },
            medium: {
                root: {
                    fontSize: '[1rem]',
                    width: '[2rem]',
                    height: '[2rem]',
                },
            },
            large: {
                root: {
                    fontSize: '[1.125rem]',
                    width: '[2.25rem]',
                    height: '[2.25rem]',
                },
            },
        },
        color: {
            default: {
                root: {
                    colorPalette: 'elements.default',
                },
            },
            primary: {
                root: {
                    colorPalette: 'elements.primary',
                },
            },
            secondary: {
                root: {
                    colorPalette: 'elements.secondary',
                },
            },
            tertiary: {
                root: {
                    colorPalette: 'elements.tertiary',
                },
            },
        },
        shape: {
            square: {
                root: {
                    borderRadius: 'sm',
                },
            },
            circle: {
                root: {
                    borderRadius: '[50%]',
                },
            },
        },
    },
    defaultVariants: {
        size: 'medium',
        shape: 'square',
        color: 'default',
    },
});

type AvatarRecipeProps = RecipeVariantProps<typeof avatarRecipe>;

export { avatarRecipe, avatarRecipe as default };
export type { AvatarRecipeProps };
